@if ($model() != null) {
    <form class="flow-object-form" [class.loading]="!$shouldShowFormBuilder()" (ngSubmit)="onSubmit()" #flowObjectForm="ngForm">
        <!-- Form Builder -->
        @if ($shouldShowFormBuilder()) {
            <div class="form-builder-wrapper" #wrapperRef>
                <form-builder [form]="$formSchema()" [options]="options" (change)="formBuilderChange($event)"></form-builder>
            </div>

            <!-- Botões -->
            <div class="form-footer form-group text-right mt-3 mb-1 mr-1">
                <hr />

                <!-- FormSchema -->
                <button type="button" class="btn btn-outline-secondary float-left ml-1"
                        (click)="showFormSchema()"
                >Editar código-fonte</button>

                <!-- Importar CSV -->
                <button type="button" class="btn btn-outline-secondary float-left ml-1"
                        (click)="showImportCsv()"
                >Importar CSV em Lista de Seleção</button>

                <!-- Cancelar -->
                <button type="button" class="btn btn-outline-danger mr-2"
                        (click)="closeForm()"
                >Cancelar</button>

                <!-- Salvar -->
                <button type="submit" class="btn btn-outline-primary"
                        [class.read-only]="$isReadOnlyMode()"
                        [disabled]="!flowObjectForm.form.valid || $isReadOnlyMode()"
                >Salvar Rascunho</button>
            </div>
        }
        <ngx-spinner name="formbuilder" bdColor="#f3f9fb" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="false"></ngx-spinner>
    </form>

    <!-- Modal do FormSchema -->
    <ng-template #formSchemaRef>
        <i class="button fas fa-times close" matTooltip="Fechar" (click)="formSchemaDialog.close()"></i>

        <button type="button" class="button btn btn-primary" (click)="Utils.copyToClipboard(formSchemaEditorRef, copyInfoRef);">
            <i class="fas fa-copy mr-2"></i>
            <span>Copiar conteúdo</span>
        </button>

        <button type="button" class="button btn btn-outline-info info" #copyInfoRef><span>Conteúdo copiado!</span></button>
        <button type="button" class="button btn btn-outline-info info" #pasteInfoRef><span>Conteúdo colado!</span></button>

        <button type="button" class="button btn btn-success right" (click)="Utils.pasteFromClipboard(formSchemaEditorRef, pasteInfoRef)">
            <i class="fas fa-paste mr-2"></i>
            <span>Colar conteúdo</span>
        </button>

        <textarea class="schema-editor form-control styled-scrollbar" [ngModel]="$formSchemaFlat()" #formSchemaEditorRef></textarea>
    </ng-template>

    <!-- Modal do Importar CSV -->
    <ng-template #importCsvRef>
        <div class="instructions-panel info-font mb-4">
            <p>
                Escolha abaixo o campo do tipo <b>Lista de Seleção</b> do formulário atual que gostaria de alterar e,
                em seguida, o arquivo CSV contendo a lista de opções personalizada. Concluída a importação com sucesso,
                o campo <b>Lista de Seleção</b> indicado terá as opções listadas no CSV <b>adicionadas</b> às opções
                existentes, caso exista alguma.
            </p>
            <p>
                O arquivo CSV deve:
            </p>

            <ul>
                <li>
                    <p>
                        conter apenas duas colunas -- <b>rotulo</b> e <b>valor</b>. Os valores podem se repetir ou não
                        entre as colunas, dependendo da necessidade. Exemplos:
                    </p>

                    <div class="example-container mb-3">
                        <table>
                            <tr><th>rotulo</th><th>valor</th></tr>
                            <tr><td>Vitória</td><td>VIX</td></tr>
                            <tr><td>Vila Velha</td><td>VV</td></tr>
                            <tr><td>Serra</td><td>SER</td></tr>
                        </table>
                        <table>
                            <tr><th>rotulo</th><th>valor</th></tr>
                            <tr><td>Vitória</td><td>Vitória</td></tr>
                            <tr><td>Vila Velha</td><td>Vila Velha</td></tr>
                            <tr><td>Serra</td><td>Serra</td></tr>
                        </table>
                    </div>
                </li>
                <li>
                    <p>
                        utilizar apenas ponto-e-vírgula (";") como separador. Arquivos CSV dos exemplos acima
                        quando abertos em um editor de texto como o <b>Bloco de Notas</b>:
                    </p>

                    <div class="example-container mb-3">
                        <div class="px-2 py-1">
                            <div>rotulo;valor</div>
                            <div>Vitória;VIX</div>
                            <div>Vila Velha;VV</div>
                            <div>Serra;SER</div>
                        </div>
                        <div class="px-2 py-1">
                            <div>rotulo;valor</div>
                            <div>Vitória;Vitória</div>
                            <div>Vila Velha;Vila Velha</div>
                            <div>Serra;Serra</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="form-group dropdown-field mb-4">
            <label for="dropdownId">Lista de Seleção a receber os dados</label>
            <select class="form-control info-font" id="dropdownId" name="dropdownId" required
                    [ngModel]="$selectedDropdown()"
                    (change)="$selectedDropdown.set($event.target.value)"
            >
                @for (option of $availableDropdownsOptions(); track option) {
                    <option [value]="option.value">{{option.description}}</option>
                }
            </select>
        </div>

        <div class="form-group csv-file mb-4">
            <label for="fileUpload">Arquivo CSV contendo os dados das opções</label>
            <file-upload [value]="$csvFile()"
                         [maxSizeMb]="10"
                         [allowedExtensions]="['csv']"
                         (valueChange)="Utils.setSignal($csvFile, $event)"
            ></file-upload>
        </div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-danger mr-2" (click)="importCsvDialog.close()">Fechar</button>

            <button type="button" class="btn btn-outline-primary"
                    [disabled]="Utils.isNullOrEmpty($selectedDropdown()) || $csvFile() == null || Utils.isEmptyObjectOrNotObject($csvFile())"
                    (click)="loadOptions()"
            >Carregar opções</button>
        </div>
    </ng-template>
}
